import { useCallback, useEffect, useState } from "react";
import type { RouteName } from "../types";

const ROUTES = new Set<RouteName>([
  "dashboard",
  "plan",
  "nutrition",
  "recovery",
  "history",
  "settings",
  "admin",
]);

function routeFromHash(): RouteName {
  const candidate = window.location.hash.replace(/^#\/?/, "") as RouteName;
  return ROUTES.has(candidate) ? candidate : "dashboard";
}

export function useHashRoute() {
  const [route, setRouteState] = useState<RouteName>(routeFromHash);

  useEffect(() => {
    const onHashChange = () => setRouteState(routeFromHash());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const setRoute = useCallback((next: RouteName) => {
    if (window.location.hash !== `#/${next}`) {
      window.location.hash = `/${next}`;
    }
    setRouteState(next);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return { route, setRoute };
}
